/* @flow */
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import { redirector } from 'auth/components/SignInPage.jsx';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const RequireUser = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      const { query } = nextState.location;
      if (CurrentUser.isSignedIn()) {
        callback();
      } else {
        const redirectToSignIn = function() {
          redirector.attemptedTransition = nextState.location;
          replaceWith('/log_in');
          callback();
        };

        if (query['auth_token']) {
          AuthActions.accessTokenSignIn(query['auth_token'])
            .then(() => callback())
            .catch(redirectToSignIn);
          return;
        }

        AuthActions.checkLoggedIn().then(user => {
          if (user) {
            callback();
          } else {
            redirectToSignIn();
          }
        })
        .catch(err => {
          console.warn('checkLoggedIn failed so redirecting to signin page', err);
          redirectToSignIn();
        });
      }
    },
  },
};

export default RequireUser;



// WEBPACK FOOTER //
// ./src/components/mixins/RequireUser.js